<div class="card auth-card mx-auto">
  <div class="card-header"><i class="fa fa-shield mr-2"></i>Enter Security Code</div>
  <div class="card-body">
    <p>A 6-digit security code has been sent to your email address. Enter it below to complete your login.</p>

    <form [formGroup]="securitycodeForm" (ngSubmit)="securitycodeForm.valid && login()" autocomplete="off">
      <app-text-input [formControl]='securitycodeForm.controls["securitycode"]' [label]='"Security Code"'></app-text-input>

      <button [disabled]='!securitycodeForm.valid' class="btn btn-primary btn-block mt-4" type="submit">Login</button>
      <button class="btn btn-outline-secondary btn-block" (click)="cancel()" type="button"><i class="fa fa-arrow-left mr-1"></i>Back</button>
    </form>
  </div>
</div>
